// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/blog`;

export const GetBlogListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "get" }) }),
    });

    if (!response.ok) throw new Error("Failed to fetch blog list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteBlog = async (recipeId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Blog?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: JSON.stringify({ action: "delete", _id: recipeId }) }),
      });

      const data = await response.json();
      if (data.success) toast.success("Blog deleted successfully");
      else toast.warning("Blog deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitBlogApi = async (blogData) => { 
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify({
      action: blogData._id ? "edit" : "add",
      _id: blogData._id,
      title: blogData.title,
      content: blogData.content
    }));

    if (blogData.imageFile) {
      formData.append("image", blogData.imageFile);
    }

    const response = await fetch(url, { method: "POST", body: formData });
    const result = await response.json();

    if (result.success || response.status === 201) {
      toast.success(blogData._id ? "Blog updated successfully" : "Blog added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save blog");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the blog");
    return null;
  }
};

export const getBlogByIdApi = async (id) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "getById", _id: id }) }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
